import { TFunction } from 'i18next';
import { FC, useMemo } from 'react';

interface Props {
  selectedGLCodes: any[];
  t: TFunction<'translation', undefined>;
}
const DeleteGLCodeModal: FC<Props> = ({ selectedGLCodes, t }) => {
  const hasMoreThanOneDepartment = useMemo(
    () => selectedGLCodes.find((glCode) => glCode.departments.length > 1),
    [selectedGLCodes]
  );

  const displayedGlCodes = useMemo(() => {
    if (hasMoreThanOneDepartment)
      return selectedGLCodes.filter((glCode) => glCode.departments.length > 1);
    else return selectedGLCodes.filter((glCode) => glCode.departments.length <= 1);
  }, [hasMoreThanOneDepartment, selectedGLCodes]);

  return (
    <div className="py-0">
      <div className="max-w-[720px] max-h-[250px] py-0">
        {hasMoreThanOneDepartment ? (
          <>
            <p>
              {t(
                'The selected GL Code(s) below exist in more than one department and will be deleted from all.'
              )}
            </p>
            <p>{t('Deleted codes can be undeleted.')}</p>
          </>
        ) : (
          <p>{t('The selected GL Code(s) will be deleted. Deleted codes can be undeleted.')}</p>
        )}
        <ul className="text-left px-3 pt-2 pb-0 overflow-auto">
          {displayedGlCodes.map((glCode) => (
            <li key={glCode} className="whitespace-pre-wrap mt-2 list-item list-disc ml-4">
              {glCode?.code || 'Unassigned'} {glCode?.description ? `- ${glCode?.description}` : ''}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DeleteGLCodeModal;
